import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConnectionsService } from '../../../../services/connections.service';
import { GetResConnection } from '../../../../models/response/get-res-conection.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BankAccountService } from '../../../../services/bank-account.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'app-connection-detail',
    templateUrl: './connection-detail.component.html',
    styleUrls: ['./connection-detail.component.css'],
    standalone: false
})
export class ConnectionDetailComponent implements OnInit {

  isEditMode: boolean = false;
  isLoaded: boolean = false;
  showConfirmDialog: boolean = false;
  connectionType!: number;
  connection!: GetResConnection;
  apiForm: FormGroup;
  banks!: { label: string, value: string, image?: string }[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private connectionService: ConnectionsService,
    private bankAccountService: BankAccountService,
    private fb: FormBuilder,
  ) { 
    this.apiForm = this.fb.group({
      bank: [''],
      clientId: [''],
      clientSecret: [''],
    });
  }

  ngOnInit() {
    const idConn = this.route.snapshot.paramMap.get('id');
    if (idConn) {
      this.isEditMode = true;
      this.loadBanks();
      this.loadConnection(idConn);
    } else {
      this.isLoaded = true;
    }
  }

  backToList() {
    this.router.navigate(['/home/conexoes']);
  }


  loadConnection(idConn: string) {
    const accessAccountId = localStorage.getItem('accessAccount') || '';
    const groupId = localStorage.getItem('groupId') || '';

    this.connectionService.getConnection(idConn, accessAccountId, groupId).subscribe({
      next: (res) => {
        console.log("Connection details response: ", res);
        res.documento = this.formatCNPJ(res.documento);
        this.connection = res;
        this.connectionType = res.connectionTypeCode;
        
      },
      error: (err) => {
        console.error(err);
      },
      complete: () => {
        this.isLoaded = true;
      }
    });
  }

  getBankName(bankCode: string): string {
    const bank = this.bankAccountService.getBankByValue(bankCode);
    return bank ? bank.label : 'Unknown Bank';
  }

  loadBanks() {
    this.banks = this.bankAccountService.getBanks();
  }

  private formatCNPJ(cnpj: string): string {
    if (!cnpj) return '';
    const cleanCnpj = cnpj.replace(/[^\d]/g, '');
    return cleanCnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  onCancelRemove(){
    this.showConfirmDialog = false;
  }

  deleteConnection() {
    console.log('Delete connection triggered');
    this.showConfirmDialog = true;
  }

  onRemoveTotal(connId: string) {
    this.connectionService.deleteConnection(connId).subscribe({
      next: () => {
        console.log('Conexão removida com sucesso');
      },
      error: () => {
        console.log('Erro ao remover conexão');
      }
    });
  }

}
